// extracted by mini-css-extract-plugin
export default {"uploadTitle":"styles_uploadTitle__sFpD-","normal":"styles_normal__ii8VS","normalList":"styles_normalList__3XCoA"};